import currencyFormatter from "currency-formatter";

const currency = {
  format: (number, precision = 0) => {
    return currencyFormatter.format(number, { code: "USD", precision });
  }
};

export default currency;
